// extracted by mini-css-extract-plugin
export default {"about_intro_video":"about_about_intro_video__CO33h","pulse-border2":"about_pulse-border2__89B4U"};